import RewardScarcity from "@Enums/RewardScarcity";
import { useTheme } from "@mui/material";
import BronzeIcon from "@Resources/app/bronze_small.png";
import GoldIcon from "@Resources/app/gold_big.png";
import RarityCommonIcon from "@Resources/app/icons-v2/rarity-icons/rarity-common-icon";
import RarityRareIcon from "@Resources/app/icons-v2/rarity-icons/rarity-rare-icon";
import RarityUncommonIcon from "@Resources/app/icons-v2/rarity-icons/rarity-uncommon-icon";
import SilverIcon from "@Resources/app/silver_big.png";

interface BybRewardIconProps {
  scarcity: RewardScarcity;
  large?: boolean;
}

export const getRarityIcon = (scarcity: RewardScarcity, color: string | undefined, theme: any): JSX.Element => {
  switch (scarcity) {
    case RewardScarcity.UNCOMMON:
      return <RarityRareIcon color={color || theme.palette.dsWarning.v400} size={12} />;
    case RewardScarcity.RARE:
      return <RarityUncommonIcon color={theme.palette.dsSurface.v400} size={12} />;
    default:
      return <RarityCommonIcon color={theme.palette.dsWarning.v400} size={12} />;
  }
};

const getImageIcon = (scarcity: RewardScarcity, large: boolean) => {
  switch (scarcity) {
    case RewardScarcity.UNCOMMON:
      return { src: SilverIcon, size: large ? 62 : 42 };
    case RewardScarcity.RARE:
      return { src: GoldIcon, size: large ? 65 : 48 };
    default:
      return { src: BronzeIcon, size: large ? 54 : 36 };
  }
};

const BybRewardIcon = ({ scarcity, large = false }: BybRewardIconProps) => {
  const theme = useTheme();
  const imageIcon = getImageIcon(scarcity, large);

  return (
    <>
      <img
        src={imageIcon.src}
        width={imageIcon.size}
        alt="icon"
        style={{
          marginTop: theme.spacing(1),
        }}
      />
    </>
  );
};

export default BybRewardIcon;
